export type TStringProperty = {
	value: string;
	epoch: number;
} | undefined;

export const convertToStringProperty = (value: string, epoch: string): TStringProperty | undefined => {
	if (!value || !epoch) {
		return undefined;
	}

	return {
		value,
		epoch: Number.parseInt(epoch, 10),
	};
};
